import { useState } from "react";
import { Cafe } from "../../../../api/types";

const useOrder = () => {
  const [selectedFranchisePub, setSelectedFranchisePub] = useState<Cafe | null>(
    null
  );
  return { selectedFranchisePub, setSelectedFranchisePub };
};

export default useOrder;
